import { gate } from 'hub-http/gates';
export const GATES = {
  GLOBAL_SEARCH: gate('settings-nav:new-global-search-icon')
};